export default {
    isLogged: state => !!state.user,
    user: state => state.user.user
}
